import { Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { BetResult } from "../types";

interface BetResultProps {
  result: BetResult;
}

export default function BetResultListItem(props: BetResultProps) {
  const result = props.result;
  const hasWon = result.betOutcome === result.wagerOutcome;
  const navigate = useNavigate();

  return (
    <Card className="p-3 mt-3" onClick={() => navigate(`/wagers/${result.wagerId}`)} style={styles.container}>
      <Card.Body>
        <Card.Title>
          <h3>{result.wagerTitle}</h3>
        </Card.Title>
        <Card.Text>
          <p>
            ${result.betTotal} bet on {result.wagerOutcomes[result.betOutcome]}
          </p>
          <h4 style={{ color: hasWon ? "green" : "red" }}>
            {hasWon ? "Win" : "Loss"}
          </h4>
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

const styles = {
  container: {
    cursor: "pointer"
  },
}